/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'service-engine';
const componentName = 'in-use-interface-list-expanded-content';
const prefix = `${moduleName}.${componentName}`;

export const floatingIpAddressesLabel = `${prefix}.floatingIpAddressesLabel`;

export const ENGLISH = {
    [floatingIpAddressesLabel]: 'Floating IP Addresses ({0})',
};
